import logoImg from '../assets/images/logo/logo.png';
import './comp_sf_footer.css'

const Comp_Sf_Footer=(props)=>{
    return(
        <div class="footer-sec pt-70px">
    <div class="container pb-70px pt-70px">
        <div class="row">
            <div class="col-md-4 footer-section pr-2">
                <img style={{"background":"#fff","padding":"10px 10px"}} src={logoImg} class="company-logo"/>
                {/* <p>Pioneering the future of financial markets through cutting-edge HFT technology. Founded in 2022 and led by Rishabh Singhal, SFintech combines ultra-low latency systems with innovative trading strategies to set new standards in Indian Capital Markets.</p> */}
            </div>
            
          
            <div class="col-md-4 footer-section pl-4 pr-4">
                {/* <center> */}
                <h5 class="white">Our Address</h5>
                <p>Mumbai, India, 380014</p>
              
              
                <p> <b>Email :</b> contact@maritime-elibrary.com</p>
                {/* </center> */}
            </div>
            
           
            <div class="col-md-4 footer-section">
                <h5 class="white">Connect With Us</h5>
                <div class="social-icons">
                    {/* <a href="#"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32" fill="currentColor"><path d="M13 9H17.5L17 11H13V20H11V11H7V9H11V7.12777C11 5.34473 11.1857 4.69816 11.5343 4.04631C11.8829 3.39446 12.3945 2.88288 13.0463 2.53427C13.6982 2.18565 14.3447 2 16.1278 2C16.6498 2 17.1072 2.05 17.5 2.15V4H16.1278C14.8041 4 14.401 4.07784 13.9895 4.29789C13.6862 4.46011 13.4601 4.68619 13.2979 4.98951C13.0778 5.40096 13 5.80407 13 7.12777V9Z"></path></svg></a> */}
                    {/* <a href="#"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32" fill="currentColor"><path d="M10.4883 14.651L15.25 21H22.25L14.3917 10.5223L20.9308 3H18.2808L13.1643 8.88578L8.75 3H1.75L9.26086 13.0145L2.31915 21H4.96917L10.4883 14.651ZM16.25 19L5.75 5H7.75L18.25 19H16.25Z"></path></svg></a> */}
                    <a target="blank" href={"javascript:void(0)"}><i class="fa fa-linkedin-square fa-2x" aria-hidden="true"></i></a>
                    
                </div>
                <p class="mt-3">Follow us on social media to stay updated with our latest news and updates.</p>
            </div>
        </div>
    </div>
</div>

    );
}
export default Comp_Sf_Footer;